import { useState } from 'react';
import { IconPhotoDown } from '@tabler/icons-react';
import { cn } from '@/lib/utils';
import { useTranslation } from '../../i18n/hooks/useTranslation';
import Hint from './Hint';
import RateChartModal from './RateChartModal';

/**
 * A button that opens the rate-chart poster editor in a full-screen window — drop it anywhere.
 *
 *   <RateChartButton />                       starts from the shop's saved price list
 *   <RateChartButton services={list} />       …or from a list you already have: [{ name, price, category? }]
 *   <RateChartButton shop={{ name, phone, address, qrUrl, logoUrl }} />   overrides the shop-profile details
 *   <RateChartButton className="mr-auto">Custom label</RateChartButton>   own placement / label
 */
export default function RateChartButton({ services, shop, className, children }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Hint label={t('rateChart.button.tip')}>
                <button
                    type="button"
                    onClick={() => setOpen(true)}
                    className={cn(
                        'inline-flex items-center gap-1.5 h-[38px] px-3.5 rounded-lg bg-primary hover:bg-primary/90 text-white shadow-sm text-[13px] font-semibold transition-colors',
                        className,
                    )}
                >
                    {children ?? (
                        <>
                            <IconPhotoDown size={16} stroke={1.9} />
                            {t('rateChart.button.label')}
                        </>
                    )}
                </button>
            </Hint>
            <RateChartModal open={open} onClose={() => setOpen(false)} services={services} shop={shop} />
        </>
    );
}
